import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import loadable from '@loadable/component';

import Loading from '@components/Loading';
import PrivateRoute from '@components/PrivateRoute';

import { createAuditTrail } from '@actions/agency';
import { logoutRequest } from '@actions/auth';

import EditAgency from '../Agency/EditAgency/EditAgency';
import PortalConfiguration from '../Agency/PortalConfiguration';
import CDBG from '../CDBG';
import { Header } from '../Header';
import ManagementTools from '../ManagementTools';

import {
  agenciesInfoURL,
  agenciesPartialURL,
  cdbgPartialURL,
  entitySectionPartialURL,
  overviewPartialURL,
  portalConfigurationURL,
  toolsPartialURL,
  violationTypesPartialURL,
} from './';

import './style.scss';

interface IHomeProps extends RouteComponentProps<{}> {
  loadingComponents: number;
  auth: IAuthStore;
  signOut: () => void;
  createAuditTrail: TAuditTrailCreateRequest;
}

const AgenciesListing = loadable(
  () =>
    import(
      /* webpackChunkName: "agency-listing" */
      '@containers/admin/Agency/AgenciesListing'
    )
);

class Home extends React.Component<IHomeProps, null> {
  readonly linksArray = [
    { path: agenciesPartialURL, title: 'Agencies' },
    { path: toolsPartialURL, title: 'Management Tools' },
    { path: cdbgPartialURL, title: 'CDBG' },
    { path: overviewPartialURL, title: 'Overview' },
  ];

  myLogout = async () => {
    const { history } = this.props;
    await this.props.createAuditTrail({
      activityType: ActivityType.LOGOUT,
      componentType: AuditComponentType.LOGOUT,
    });
    this.props.signOut();

    history.push('/login');
  };

  render() {
    return (
      <div id="admin-container">
        <header>
          <Header links={this.linksArray} />
        </header>
        <main className="comcate-admin-app">
          <Switch>
            <PrivateRoute exact path={agenciesPartialURL} component={AgenciesListing} acl={ACL.COMCATE_ADMIN} />
            <PrivateRoute exact path={agenciesInfoURL} component={EditAgency} acl={ACL.COMCATE_ADMIN} />
            <PrivateRoute exact path={portalConfigurationURL} component={PortalConfiguration} acl={ACL.COMCATE_ADMIN} />
            <PrivateRoute exact path={violationTypesPartialURL} component={ManagementTools} acl={ACL.COMCATE_ADMIN} />
            <PrivateRoute
              exact
              path={`${entitySectionPartialURL}`}
              component={ManagementTools}
              acl={ACL.COMCATE_ADMIN}
            />
            <PrivateRoute exact path={cdbgPartialURL} component={CDBG} acl={ACL.COMCATE_ADMIN} />
            <Redirect from={toolsPartialURL} to={violationTypesPartialURL} />
            <Redirect from="/" to="/agencies" />
          </Switch>
          <Loading show={this.props.loadingComponents > 0} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxStore) => ({
  auth: state.auth,
  loadingComponents: state.appState.loadingComponents,
});

const mapDispatchToProps = (dispatch: any) => ({
  signOut: () => dispatch(logoutRequest()),
  createAuditTrail: (request: IAuditTrailCreateRequest) => dispatch(createAuditTrail(request)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
